module.exports = __webpack_public_path__ + "img/tab3.6304edfe.png";